<div class="multi-select">
    <div class="multi-select-input" [ngClass]="{ 'multi-select-input-opened': optionsVisible }" (click)="toggleOptions()">
        <img src="assets/images/common/filter.svg" class="filter-img" alt="filter" />
        <div class="filter-text">Filters</div>
    </div>
    <div class="multi-select-options" *ngIf="optionsVisible" (clickOutside)="hideOptions()" [delayClickOutsideInit]="true">
        <div class="multi-select-options-reset-all" (click)="clearSelections()">Reset All</div>
        <div class="multi-select-options-container">
            <div *ngFor="let optionGroup of optionsInsideCategories$ | async; let i = index">
                <div *ngIf="!optionGroup.displayName">
                    <div
                        *ngFor="let option of optionGroup.options"
                        class="multi-select-option"
                        [ngClass]="{
                            'multi-select-option-selected': selectedIds.has(option.id) && !option.disabled,
                            'multi-select-option-disabled': option.disabled,
                        }"
                        (click)="onSelect(option.id)">
                        <mat-checkbox color="primary" [checked]="selectedIds.has(option.id)"> </mat-checkbox>
                        <div class="multi-select-option-text" appLongTextTooltip>
                            {{ option.displayName | beautifyDisplayString }}
                        </div>
                    </div>
                </div>
                <div *ngIf="optionGroup.displayName && !optionGroup.isDynamic">
                    <app-accordion
                        [inMultiSelect]="true"
                        [expanded]="selectedCategoriesDisplayName.has(optionGroup.displayName)"
                        [accordionTitle]="optionGroup.displayName | beautifyDisplayString">
                        <div
                            *ngFor="let option of optionGroup.options"
                            class="multi-select-option"
                            [ngClass]="{
                                'multi-select-option-selected': selectedIds.has(option.id) && !option.disabled,
                                'multi-select-option-disabled': option.disabled,
                            }"
                            (click)="onSelect(option.id)">
                            <mat-checkbox [checked]="selectedIds.has(option.id)"> </mat-checkbox>
                            <img *ngIf="option.iconPath" [src]="option.iconPath" class="option-img" />
                            <div class="multi-select-option-text" appLongTextTooltip>
                                {{ option.withoutBeautifyDisplayName ? option.displayName : (option.displayName | beautifyDisplayString) }}
                            </div>
                        </div>
                    </app-accordion>
                </div>
                <div class="dynamicSelect" *ngIf="optionGroup.isDynamic">
                    <app-accordion [inMultiSelect]="true" [accordionTitle]="optionGroup.displayName | beautifyDisplayString">
                        <ng-content select="[dynamicSelect]"></ng-content>
                    </app-accordion>
                </div>
            </div>
        </div>
    </div>
</div>
